import {
  CircuitBoard, Move3D, Radar, Cog, Sparkles, Store, Handshake, Box, Search,
} from "lucide-react";

const TILES = [
  { label: "Components", icon: CircuitBoard },
  { label: "Actuators", icon: Move3D },
  { label: "Sensors", icon: Radar },
  { label: "Motors", icon: Cog },
  { label: "AI Sourcing", icon: Sparkles, live: true },
  { label: "Marketplace", icon: Store },
  { label: "Suppliers", icon: Handshake },
  { label: "CAD", icon: Box },
];

export default function HeroDashboard({ onOpenAI }) {

  const handleTile = (t) => {
    if (t.live) onOpenAI?.();
    else onOpenAI?.(`I'm looking for ${t.label.toLowerCase()} for my robot build. What do you recommend?`);
  };

  return (
    <div className="scene float-in w-full" data-testid="hero-dashboard">
      <div className="panel-tilt relative">
        {/* L-shaped header: wordmark notch + search */}
        <div className="flex items-stretch gap-3">
          <div className="glass flex w-[150px] flex-col justify-center rounded-2xl px-5 py-4">
            <div className="flex items-center gap-2">
              <span className="grid grid-cols-3 gap-[3px]">
                {[...Array(9)].map((_, i) => (
                  <span key={i} className={`h-[3px] w-[3px] rounded-full ${i % 2 === 0 ? "bg-[#1C2A38]" : "bg-[#9aa3ad]"}`} />
                ))}
              </span>
              <span className="font-wordmark text-lg font-700 tracking-tight text-[#1C2A38]">ROSA</span>
            </div>
          </div>
          <div className="glass flex flex-1 items-center gap-3 rounded-2xl px-5 py-4">
            <Search className="h-4 w-4 shrink-0 text-[#5b6878]" />
            <span className="truncate text-sm text-[#5b6878]">Devices, parts, suppliers…</span>
          </div>
        </div>

        {/* Tiles grid — crops off right edge */}
        <div className="mt-3 grid w-[135%] grid-cols-4 gap-3">
          {TILES.map((t, i) => {
            const Icon = t.icon;
            return (
              <button
                key={t.label}
                onClick={() => handleTile(t)}
                data-testid={`hero-tile-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`tile group relative flex aspect-square flex-col justify-between rounded-2xl p-4 text-left ${t.live ? "tile-live" : ""}`}
                style={{ animationDelay: `${0.1 + i * 0.05}s` }}
              >
                <div className="flex items-start justify-between">
                  <Icon
                    className={`h-7 w-7 ${t.live ? "text-[var(--teal)]" : "text-[#1C2A38]"}`}
                    strokeWidth={1.6}
                  />
                  {t.live && (
                    <span className="live-dot mt-1 h-2.5 w-2.5 rounded-full bg-[var(--teal)]" />
                  )}
                </div>
                <div>
                  {t.live && (
                    <span className="font-mono-tech text-[10px] font-600 uppercase tracking-widest text-[var(--teal-deep)]">
                      Live
                    </span>
                  )}
                  <div className={`font-display text-sm font-700 ${t.live ? "text-[#1C2A38]" : "text-[#3c4a5a]"}`}>
                    {t.label}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
